export default __webpack_public_path__ + "static/media/Ct13.c3296325.png";